import config from './config';

function getListPeerings(params) {
	return Ajax.get(config.listPeerings, params);	
}

function getPeeringStatus() {
	return Ajax.get(config.peeringStatus);	
}
export {
	getListPeerings,
	getPeeringStatus
};


// WEBPACK FOOTER //
// ./src/api/peering/list/actions.js